




























































import Bugsnag from '@bugsnag/js';
import CoText from '@/components/Atoms/co-text/CoText.vue';
import CoAlert from '@/components/Molecules/co-alert/CoAlert.vue';

export default {
    name: 'SaaSBase',
    components: {
        CoText,
        CoAlert,
    },
    created() {
        this.addCoappScripts();
    },
    computed: {
        // Check if localStorage is enabled
        localStorageEnabled() {
            if (!this.$isLocalStorage) {
                Bugsnag.notify(
                    new Error('LocalStorage is not available in Community Creation. User cannot use the app.')
                );
                return false; // localStorage check not performed yet
            }
            return this.$isLocalStorage;
        },
    },
    methods: {
        addCoappScripts() {
            // stripe price table
            const dynamicScript3 = document.createElement('script');
            dynamicScript3.setAttribute('src', 'https://js.stripe.com/v3/pricing-table.js');
            dynamicScript3.async = true;
            document.head.appendChild(dynamicScript3);

            // matomo tracking
            const dynamicScript4 = document.createElement('script');
            dynamicScript4.setAttribute('src', '/static/scripts/matomo.js');
            dynamicScript4.async = true;
            document.head.appendChild(dynamicScript4);
        },
    },
};
